(function () {
  if (window.__bundleGuardInitialized) return;
  window.__bundleGuardInitialized = true;

  const SETTINGS = {
    requiredChildrenPerParent: 4,
    refKey: "_bundle_ref",
    roleKey: "_bundle_role",
    parentRole: "parent",
    childRole: "child",
    parentMaxQty: 1,
    maxFixPasses: 3,
  };

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("cart fetch failed");
    return res.json();
  }

  function findCheckoutButtons(scope = document) {
    const selectors = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[formaction*="/checkout"]',
      'a[href^="/checkout"]',
      'a[href*="/checkout"]',
      ".cart__checkout-button",
      ".cart__ctas button",
      ".cart__ctas input",
    ];
    return Array.from(scope.querySelectorAll(selectors.join(","))).filter(Boolean);
  }

  function setCheckoutBlocked(blocked) {
    const buttons = findCheckoutButtons(document);
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      const tag = btn.tagName.toLowerCase();

      if (tag === "a") {
        if (blocked) {
          btn.dataset.bundleGuardHref = btn.getAttribute("href") || "";
          btn.setAttribute("href", "javascript:void(0)");
          btn.setAttribute("aria-disabled", "true");
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.6";
        } else {
          const old = btn.dataset.bundleGuardHref;
          if (old) btn.setAttribute("href", old);
          btn.removeAttribute("aria-disabled");
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
        }
      } else {
        if (blocked) {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-disabled", "true");
        } else {
          btn.removeAttribute("disabled");
          btn.removeAttribute("aria-disabled");
        }
      }
    });
  }

  async function changeLineByKey(key, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!res.ok) throw new Error("cart change failed");
    return res.json();
  }

  function analyze(cart) {
    const parentRefs = new Set();

    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      const ref = props[SETTINGS.refKey];
      if (!ref) return;
      const role = props[SETTINGS.roleKey] || "";
      if (role === SETTINGS.parentRole) parentRefs.add(ref);
    });

    const fixes = [];
    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      const ref = props[SETTINGS.refKey];
      if (!ref) return;

      const role = props[SETTINGS.roleKey] || "";

      // enfant orphelin
      if (role === SETTINGS.childRole && !parentRefs.has(ref)) {
        fixes.push({ key: item.key, quantity: 0 });
        return;
      }

      // parent > 1
      if (
        role === SETTINGS.parentRole &&
        SETTINGS.parentMaxQty &&
        (item.quantity || 0) > SETTINGS.parentMaxQty
      ) {
        fixes.push({ key: item.key, quantity: SETTINGS.parentMaxQty });
      }
    });

    const groups = new Map();
    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      const ref = props[SETTINGS.refKey];
      if (!ref) return;

      const role = props[SETTINGS.roleKey] || "";
      const g = groups.get(ref) || { parentsQty: 0, childrenQty: 0 };
      if (role === SETTINGS.parentRole) g.parentsQty += item.quantity || 0;
      if (role === SETTINGS.childRole) g.childrenQty += item.quantity || 0;
      groups.set(ref, g);
    });

    let incomplete = false;
    for (const g of groups.values()) {
      if (!g.parentsQty) continue;
      const expected = g.parentsQty * SETTINGS.requiredChildrenPerParent;
      if (g.childrenQty !== expected) {
        incomplete = true;
        break;
      }
    }

    return { fixes, incomplete };
  }

  async function applyFixesFast(fixes) {
    // dédoublonnage key
    const byKey = new Map();
    fixes.forEach((f) => byKey.set(f.key, f.quantity));
    const uniqueFixes = Array.from(byKey.entries()).map(([key, quantity]) => ({ key, quantity }));
    if (!uniqueFixes.length) return false;

    // ⚡ en parallèle (très rapide pour 3 items)
    await Promise.all(uniqueFixes.map((f) => changeLineByKey(f.key, f.quantity)));
    return true;
  }

  function shouldRunNow() {
    if (location.pathname === "/cart") return true;
    if (document.querySelector("cart-drawer")) return true;
    return false;
  }

  let scheduled = false;
  let fixPasses = 0;

  async function checkNow() {
    if (!shouldRunNow()) return;
    if (window.__bundleGuardBusy) return;

    try {
      window.__bundleGuardBusy = true;

      let cart = await fetchCart();
      let { fixes, incomplete } = analyze(cart);

      if (fixes.length && fixPasses < SETTINGS.maxFixPasses) {
        fixPasses += 1;

        const changed = await applyFixesFast(fixes);

        if (changed) {
          cart = await fetchCart();
          ({ fixes, incomplete } = analyze(cart));

          try {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.dispatchEvent(new CustomEvent("cart:change"));
          } catch (_) {}

          if (location.pathname === "/cart") {
            setTimeout(() => {
              if (!sessionStorage.getItem("__bundleGuardReloaded")) {
                sessionStorage.setItem("__bundleGuardReloaded", "1");
                location.reload();
              }
            }, 60); // plus rapide
          }
        }
      } else if (!fixes.length) {
        sessionStorage.removeItem("__bundleGuardReloaded");
        fixPasses = 0;
      }

      setCheckoutBlocked(Boolean(incomplete));
    } catch (e) {
      setCheckoutBlocked(false);
    } finally {
      window.__bundleGuardBusy = false;
    }
  }

  function scheduleCheck(immediate = false) {
    if (immediate) return void checkNow();

    if (scheduled) return;
    scheduled = true;
    setTimeout(async () => {
      scheduled = false;
      await checkNow();
    }, 30); // ⚡ au lieu de 120
  }

  // ---------- ⚡ Accélération : hook sur clic "supprimer" du parent ----------
  function bindInstantParentDelete() {
    // capture phase pour partir avant que Dawn fasse son fetch
    document.addEventListener(
      "click",
      async (e) => {
        const btn = e.target && e.target.closest
          ? e.target.closest('a[href*="cart/change"], button[name="update"], button[aria-label*="Supprimer"], button[aria-label*="Remove"], cart-remove-button button')
          : null;

        if (!btn) return;

        // on check immédiatement (optimiste) : si un parent va disparaître,
        // on supprimera les orphelins juste après le changement.
        // => déclenche un check quasi immédiat
        scheduleCheck(true);
      },
      true
    );
  }

  function observeCartMutations() {
    const target =
      document.querySelector("cart-drawer, cart-items, .cart__contents, .drawer__contents") || document.body;

    const obs = new MutationObserver(() => scheduleCheck(false));
    obs.observe(target, { childList: true, subtree: true });
  }

  function observeDrawerOpen() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    const isOpen = () =>
      drawer.hasAttribute("open") ||
      drawer.classList.contains("active") ||
      drawer.getAttribute("aria-hidden") === "false";

    const obs = new MutationObserver(() => {
      if (isOpen()) scheduleCheck(false);
    });

    obs.observe(drawer, { attributes: true, attributeFilter: ["class", "open", "aria-hidden"] });
  }

  function patchFetchOnce() {
    if (window.__bundleGuardFetchPatched) return;
    window.__bundleGuardFetchPatched = true;

    const orig = window.fetch.bind(window);
    window.fetch = async (...args) => {
      const res = await orig(...args);
      try {
        const url = args[0] instanceof Request ? args[0].url : String(args[0] || "");
        if (url.includes("/cart/") || url.includes("/cart.js")) {
          scheduleCheck(false);
        }
      } catch (_) {}
      return res;
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    patchFetchOnce();
    bindInstantParentDelete();
    observeDrawerOpen();
    observeCartMutations();

    if (location.pathname === "/cart") scheduleCheck(true);
  });

  window.BundleGuard = { checkNow, scheduleCheck };
})();
